export default __webpack_public_path__ + "static/teacher1-2b2cb804f70dfe93d32a1f1482ef8516.png";